import { z } from "zod/mini"

export const SeparatorContentType = "SeparatorContent" as const

export const SeparatorContentSchema = z.object({
	__TYPE__: z.literal(SeparatorContentType),
})

export type SeparatorContent = z.infer<typeof SeparatorContentSchema>
